/*
 * Post-sign-in HOME (Duncan 2026-10-21): a purchaser who still has seats to
 * assign lands on Orders first (assign, then get ready); everyone else on Get
 * ready. One small my-api count read (GET /me/orders/unassigned-summary),
 * bounded by HOME_CHOICE_TIMEOUT_MS — slow, failing, signed-out or an older
 * my-api (404) all fall back to Get ready, so home never hangs.
 * Deep links never come here: Login returns to the path it was opened on.
 */
import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { loadSession } from '../auth/session'
import { fetchUnassignedSeats, myApiBase } from '../data/myApi'

export const HOME_CHOICE_TIMEOUT_MS = 1500

export function HomeRedirect() {
  const [target, setTarget] = useState<string | null>(null)
  useEffect(() => {
    const session = loadSession()
    const base = myApiBase()
    if (!session || !base) {
      setTarget('/get-ready')
      return
    }
    let live = true
    const ctl = new AbortController()
    const timer = setTimeout(() => ctl.abort(), HOME_CHOICE_TIMEOUT_MS)
    fetchUnassignedSeats(session.idToken, base, ctl.signal)
      .then((n) => live && setTarget(n > 0 ? '/orders' : '/get-ready'))
      .catch(() => live && setTarget('/get-ready'))
      .finally(() => clearTimeout(timer))
    return () => {
      live = false
      clearTimeout(timer)
      ctl.abort()
    }
  }, [])
  return target ? <Navigate to={target} replace /> : null
}
